module.exports = __webpack_public_path__ + "img/ss_green-04.ec42d3d7.jpg";